import template from './mission.html'

export default {
  template,
  controller: 'missionController as mission',
  bindings: {
    data: '<'
  }
}
